import React from 'react';
import * as log from 'loglevel';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import i18n from 'react-intl-universal';
import IconButton from '@material-ui/core/IconButton';
import BackButton from '@material-ui/icons/ArrowBack';
import classnames from 'classnames';
import { resetGlobalErrorMessage } from '../actions';
import ErrorMessage from './ErrorMessage';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { renderingError: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      renderingError: {
        error,
        errorInfo
      }
    });
    const { broker } = this.props;
    if (broker) {
      broker.onError(error, errorInfo);
    }

    log.error(error, errorInfo);
  }

  defaultMessage = () => ({
    reason: 'Unknown error',
    heading: i18n.get('app.commons.errors.global.unknown.heading'),
    remedy: i18n.get('app.commons.errors.global.unknown.remedy')
  });

  getRenderingErrorMessage = () => {
    let message = this.defaultMessage();
    message.reason = this.state.renderingError.error.toString();
    return message;
  };

  getOtherErrorMessage = () => {
    let message = this.defaultMessage();
    if (
      this.props.error &&
      this.props.error.payload &&
      this.props.error.payload.message
    ) {
      const payload = this.props.error.payload;
      if (payload.name === 'RequestError') {
        message.heading = i18n.get(
          'app.commons.errors.global.noInternet.heading'
        );
        message.remedy = i18n.get(
          'app.commons.errors.global.noInternet.remedy'
        );
      }
      message.reason = payload.message;
    }
    return message;
  };

  render() {
    const { classes } = this.props;

    if (this.state.renderingError) {
      // rendering error, remove entire dom
      return (
        <div className={classes.errorWall}>
          <section className={classes.errorContainer}>
            <ErrorMessage msg={this.getRenderingErrorMessage()} withLogo />
          </section>
        </div>
      );
    }

    return (
      <React.Fragment>
        {// closable errors, on top of dom
        this.props.error ? (
          <div className={classnames(classes.errorWall, classes.transparent)}>
            <IconButton
              className={classes.closeIcon}
              aria-label="Delete"
              onClick={this.props.resetGlobalErrorMessage}
            >
              <BackButton />
            </IconButton>
            <section className={classes.errorContainer}>
              <ErrorMessage msg={this.getOtherErrorMessage()} />
            </section>
          </div>
        ) : null}
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    error: state.error
  }),
  dispatch => ({
    resetGlobalErrorMessage: () => dispatch(resetGlobalErrorMessage())
  })
)(withStyles(styles)(ErrorBoundary));
